// @module BTM.NortonShoppingGuarantee.NortonShoppingGuarantee
define('BTM.NortonShoppingGuarantee.NortonShoppingGuarantee.Footer.View', [
	'SC.Configuration', 'btm_nortonshoppingguarantee_nortonshoppingguarantee_footer.tpl', 'Utils', 'Backbone', 'jQuery', 'underscore'
], function (
	Configuration, btm_nortonshoppingguarantee_nortonshoppingguarantee_footer_tpl, Utils, Backbone, jQuery, _
) {
	'use strict';

	// @class BTM.NortonShoppingGuarantee.NortonShoppingGuarantee.View @extends Backbone.View
	return Backbone.View.extend({

		template: btm_nortonshoppingguarantee_nortonshoppingguarantee_footer_tpl

			,
		initialize: function (options) {}

			,
		events: {}

		,
		bindings: {}

		,
		childViews: {

		}

		//@method getContext @return BTM.NortonShoppingGuarantee.NortonShoppingGuarantee.View.Context
		,
		getContext: function getContext() {
			return {};
		}
	});
});
